//Plugin BuddyForms custom scripts


/**
 * Auto hide/show field : Lorier "document_type"
 */
 (function($) {
    
    if( $('.the_buddyforms_form .input-conditional').length ){

        buddyforms_condInputs_DocumentType();
    }

    function buddyforms_condInputs_DocumentType(){
        var documentType = $('input[name=document_type]:checked').val();

        if( documentType == 'file' ){
            $('.input-conditional .elem-document_file').show();
            $('.input-conditional .elem-document_url').hide();
        }else{
            $('.input-conditional .elem-document_file').hide();
            $('.input-conditional .elem-document_url').show();
        }
    }

    $('input[name=document_type]').change(function(){
        buddyforms_condInputs_DocumentType();
        console.log('Document Type changed');
    });
    
    /**
     * Archive post function
     * 
     * Cette fonction permet d'archiver un post (le passer en statut 'archive')
     */
    $(document).on("click", '.bf_archive_post', function() {
        var post_id = $(this).attr('id');
        
        // var action_str_archive = bf_trans('Archive this post');
        // action_str_archive = BuddyFormsHooks.applyFilters('buddyforms_global_archive_text', action_str_archive, [post_id]);

        // Use a custom translation function if available
        // var action_str_archive = 'Are you sure you want to archive this post?';
        //French translation example
        var action_str_archive = 'Êtes-vous sûr de vouloir archiver ce contenu ?';

        if (confirm(action_str_archive)) {
            $.ajax({
                type: 'POST',
                url: buddyformsGlobal.admin_url,
                data: {"action": "buddyforms_ajax_archive_post", "post_id": post_id},
                success: function (data) {
                    if (isNaN(data)) {
                        alert(data);
                    } else {
                        location.reload();
                    }
                },
                error: function (request) {
                    alert(request.responseText);
                }
            });
        } else {
            return false;
        }
        return false;
    });
    
    /**
     * Publish post function
     * 
     * Cette fonction permet de publier un post archivé (le passer en statut 'publish')
     */
    $(document).on("click", '.bf_publish_post', function() {
        var post_id = $(this).attr('id');

        // var action_str_publish = bf_trans('Publish this post');
        // action_str_publish = BuddyFormsHooks.applyFilters('buddyforms_global_publish_text', action_str_publish, [post_id]);

        // Use a custom translation function if available
        // var action_str_publish = 'Are you sure you want to publish this post?';
        //French translation example
        var action_str_publish = 'Êtes-vous sûr de vouloir publier ce contenu sur le portail LORIER ?';
        
        if (confirm(action_str_publish)) {
            $.ajax({
                type: 'POST',
                url: buddyformsGlobal.admin_url,
                data: {"action": "buddyforms_ajax_publish_post", "post_id": post_id},
                success: function (data) {
                    if (isNaN(data)) {
                        alert(data);
                    } else {
                        location.reload();
                    }
                },
                error: function (request) {
                    alert(request.responseText);
                }
            });
        } else {
            return false;
        }
        return false;
    });

    /**
     * Unpublish post function
     * 
     * Cette fonction permet de repasser un post publié en mode brouillon (statut 'in-progress')
     */
    $(document).on("click", '.bf_unpublish_post', function() {
        var post_id = $(this).attr('id');

        var action_str_unpublish = 'Êtes-vous sûr de vouloir repasser ce contenu en mode brouillon (collaboration interne) ? Il sera visible uniquement dans l\'espace de travail.';
        
        if (confirm(action_str_unpublish)) {
            $.ajax({
                type: 'POST',
                url: buddyformsGlobal.admin_url,
                data: {"action": "buddyforms_ajax_unpublish_post", "post_id": post_id},
                success: function (data) {
                    if (isNaN(data)) {
                        alert(data);
                    } else {
                        location.reload();
                    }
                },
                error: function (request) {
                    alert(request.responseText);
                }
            });
        } else {
            return false;
        }
        return false;
    });

})(jQuery);


